import TableOrder from '../../../common/table/order';

export default class CatalogTableAccountOrder extends TableOrder {

  _initTableLinks() {

    super._initTableLinks();

    this.table_element.find('.button_pay').click(function (event) {
      event.preventDefault();
      FASTWAX.MODULE_ORDER.showPaymentForm($(this).data('order_id'));
      return false;
    });

    this.table_element.find('.button_cancel').click(function (event) {
      event.preventDefault();
      FASTWAX.MODULE_ORDER.cancelOrder($(this).data('order_id'), $(this).data('order_number'));
      return false;
    });

  }

  init() {
    super.init();
  }

  _reinitDynamicBlock(html) {
    super._reinitDynamicBlock(html);
  }
  
  _processWrongResult(result) {

    if (result.hasOwnProperty('error') && result.error.length) {
      
      if(typeof window.closeTransMsg === 'function') {
        window.closeTransMsg();
      }
      
      alert(result.error);
      return;
    }

    if(result.hasOwnProperty('redirect_url') && result.redirect_url.length) {
      window.location.href = result.redirect_url;
      return;
    }
  };
  
  _resetFilterForm() {
    this._resetFilterFormDefaultValues();
    this._submitFilterForm(false);
    this._initFilterFormVisibility();
    this._initFilterFormDisplayButtonText();
  }
}


/** WEBPACK FOOTER **
 ** ./src/catalog/table/account/order.js
 **/